/**
 * هيكل تحميل بدل نص «جارى التحميل…»: أسطر رمادية بشكل المحتوى القادم فلا تقفز
 * الصفحة حين يصل. النص نفسه باقٍ لقارئ الشاشة.
 */
export default function Loading({ lines = 3 }: { lines?: number }) {
  return (
    <div className="skeleton" role="status" aria-live="polite">
      <span className="sr-only">جارى التحميل…</span>
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} className="skeleton-line" aria-hidden="true" />
      ))}
    </div>
  );
}
